import { GetRequestInterface } from "../../interfaces/ActionReducer/GetMethod/GetRequest";
import { LanguageInterface } from "../MultiLingual/types";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const CURRENT_USER_RECEIVED = "CURRENT_USER_RECEIVED";
export const UPDATE_CURRENT_USER_LANGUAGE = "UPDATE_CURRENT_USER_LANGUAGE";
export const GET_CONSTANTS = "GET_CONSTANTS";
export const CONSTANTS_RECEIVED = "CONSTANTS_RECEIVED";

export interface groupsInterface {
    id: number;
    name: string;
}

export interface constantsInterface {
    [prop: string]: string | Array<string> | number | Array<number>;
}

export interface CurrentUserInterface {
    id: number;
    language: LanguageInterface;
    username: string;
    groups: groupsInterface[];
    email: string;
    date_joined: string;
    last_login: string;
    first_name: string;
    last_name: string;
}

export interface UpdateLanguageInterface {
    language_id: number;
}

export interface GetCurrentUser {
    type: typeof GET_CURRENT_USER;
    payload: { params: GetRequestInterface };
}

export interface ReceivedCurrentUser {
    type: typeof CURRENT_USER_RECEIVED;
    payload: { currentUser: CurrentUserInterface };
}

export interface UserStateInterface {
    currentUser: CurrentUserInterface | null;
    isCurrentUserReceived: boolean;
    constants: constantsInterface | null;
}

export interface UpdateCurrentUserLanguageInterface {
    type: typeof UPDATE_CURRENT_USER_LANGUAGE;
    payload: { id: number; data: UpdateLanguageInterface };
}

export interface GetConstantsInterface {
    type: typeof GET_CONSTANTS;
    params: GetRequestInterface;
}

export interface ConstantsReceivedInterface {
    type: typeof CONSTANTS_RECEIVED;
    payload: { constants: constantsInterface };
}

export type UserState = UserStateInterface;

export type UserTypes =
    | GetCurrentUser
    | ReceivedCurrentUser
    | UpdateCurrentUserLanguageInterface
    | GetConstantsInterface
    | ConstantsReceivedInterface;
